import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ErrorLogDetails extends Vue {
  public get log() {
    return this.$store.getters.postbackErrorLog;
  }
  public get content() {
    if (this.log) {
      return this.log.message;
    }
    return '';
  }
}
